export enum MediaApiUrls {
  YOUTUBE = '/api/media?type=youtube',
}
